/* ============
 * EXCISE DUTIES Module State
 * ============
 */

export default {
  all: [],
  packaging: [],
  basic: [],
  pagination: {
    currentPage: 1,
    lastPage: 0,
    limit: 5,
    totalCount: 0,
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/exciseGroup/state.js